import "cross-fetch/polyfill";
import { HTTP_OK } from "../../constants/http";
import { HttpError } from "../errors/http";
import { isBrowser } from "../environmentDetection/library";

const NODE_REQUEST_TIMEOUT = 20000;

const setRequestHeaders = (header = {}) => {
    if (isBrowser()) {
        return header;
    }

    return {
        ...header,
        "User-Agent": `CBC/Ocelot/${
            process.env.RELEASE_NAME || process.env.COMMIT_HASH || ""
        }`,
    };
};

export async function request(url, options = {}) {
    const headers = options.headers
        ? setRequestHeaders(options.headers)
        : setRequestHeaders();
    options.headers = headers;
    const timeout = isNaN(options.timeout)
        ? NODE_REQUEST_TIMEOUT
        : options.timeout;
    const controller = new AbortController();
    const id = setTimeout(() => controller.abort(), timeout);
    options.signal = controller.signal;
    try {
        const resp = await fetch(url, options);
        clearTimeout(id);
        return resp;
    } catch (error) {
        if (error && error.message === "Failed to fetch") {
            error.message = `(request) Unable to fetch ${url}`;
            error.extraData = options;
        }
        throw error;
    }
}

const isJSON = (res) => {
    return (
        res.headers.get("content-type") &&
        /application\/json/i.test(res.headers.get("content-type"))
    );
};

const testOK = (res) => {
    if (res.status !== HTTP_OK) {
        return Promise.reject(new HttpError(res.status, res.statusText));
    } else if (!isJSON(res)) {
        return Promise.reject(
            `Invalid content-type ${res.headers.get("content-type")}`
        );
    } else {
        return res;
    }
};

export function requestJSON(url, options = {}) {
    return request(url, options)
        .then(testOK)
        .then((res) => res.json());
}
// Taken from: https://reactjs.org/blog/2015/12/16/ismounted-antipattern.html<Paste>
export function makeCancelable(promise) {
    let canceled = false;
    return {
        promise: new Promise((resolve, reject) => {
            promise
                .then((val) => !canceled && resolve(val))
                .catch((error) => !canceled && reject(error));
        }),
        cancel: () => (canceled = true),
    };
}
